import _ from 'underscore';
import { useContext, useMemo } from 'react';
import { InstrumentationContext } from '@bingads-webui-react/hoc-with-instrumentation';

const backupLogger = {
  trace: _.noop,
  error: _.noop,
  signal: _.noop,
};

export const getInstrumentLogger = (instrumentation, scenarioName, activityName) => {
  if (!instrumentation || !scenarioName || !activityName) {
    return backupLogger;
  }

  try {
    let scenario;
    if (!instrumentation[scenarioName]) {
      scenario = instrumentation.createScenario({
        scenarioName,
        activityName,
      });
    } else {
      scenario = instrumentation[scenarioName].create();
    }

    let activity;
    if (!scenario[activityName]) {
      activity = scenario.createActivity(activityName);
    } else {
      activity = scenario[activityName].create();
    }

    return activity;
  } catch (e) {
    return backupLogger;
  }
};

export const useInstrumentLogger = ({ scenarioName = '', activityName = '' } = {}) => {
  const instrumentation = useContext(InstrumentationContext);
  const logger = useMemo(() => getInstrumentLogger(instrumentation, scenarioName, activityName), [activityName, instrumentation, scenarioName]);

  return logger;
};
